import { useState } from 'react';
import { useAsyncFunc } from 'commons/hooks';
import accountServices from 'domains/Account/accountServices';

interface UseGetBusinessPhoneResult {
  phoneNumber: string;
  isLoading: boolean;
  isError: boolean;
  fetchBusinessPhone: () => void;
}

/**
 * Fetches the store's business phone from Cirrus and exposes loading/error state.
 * Returns an empty string when the phone is absent.
 */
function useGetBusinessPhone(): UseGetBusinessPhoneResult {
  const [phoneNumber, setPhoneNumber] = useState<string>('');

  const [fetchBusinessPhone, isLoading, isError] = useAsyncFunc(async () => {
    const result = await accountServices.getBusinessData();
    setPhoneNumber((result?.values?.phoneNumber ?? '').trim());
  });

  return {
    phoneNumber,
    isLoading,
    isError,
    fetchBusinessPhone,
  };
}

export default useGetBusinessPhone;
